/**
 * CompositionEnginePage - Visual workflow composition dashboard
 *
 * Surfaces the CompositionEngineDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides visual workflow composition with fragment management and validation.
 *
 * Route: /admin/composition-engine
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconPuzzle } from '@tabler/icons-react';

import { CompositionEngineDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function CompositionEnginePage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="lime">
            <IconPuzzle size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Composition Engine</Title>
            <Text size="sm" c="dimmed">
              Visual workflow composition with fragment management and validation
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <CompositionEngineDashboard tenantId={tenant?.id ?? ''} />
    </Container>
  );
}

export default CompositionEnginePage;
